import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlternateEmail = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.0021 21.0037H12C7.02736 21.0037 2.99625 16.9726 2.99625 12C2.99625 7.02733 7.02736 2.99622 12 2.99622C16.9726 2.99622 21.0037 7.02733 21.0037 12V13.5006C21.0037 14.8819 19.884 16.0016 18.5027 16.0016C17.1214 16.0016 16.0017 14.8819 16.0017 13.5006V12C16.0017 9.78991 14.2101 7.9983 12 7.9983V7.9983C9.78994 7.9983 7.99833 9.78991 7.99833 12C7.99833 14.21 9.78994 16.0016 12 16.0016C14.2101 16.0016 16.0017 14.21 16.0017 12",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgAlternateEmail);
export default ForwardRef;
